import { Injectable } from '@angular/core';

import { PopupRendererService } from '../../renderer/popup-renderer.service';
import { MapService } from '../../map/map.service';
import { MapConfigService } from '../../config/map-config.service';

@Injectable()
export class PopupDrawerService {

    /**
     * Service constructor
     * @param $map map service
     * @param $popup popup renderer service
     * @param $cluster cluster service
     */
    public constructor(
        private $map: MapService,
        private $popup: PopupRendererService,
        private $mapConfig: MapConfigService
    ) { }

    /**
     * Przelaczenie widzialnosci okien informacyjnych
     */
    public toggleClusterPopupsVisibility(): boolean {
        let flag = this.$mapConfig.getShowPopupsFlag();
        flag = !flag;
        this.$mapConfig.setShowPopupsFlag(flag);

        const markers = this.$map.groups.clusters;
        markers.eachLayer((m: any) => {
            const marker = <any>m;
            const options = marker.options;
            if (options.isPopupVisible !== undefined) {
                options.isPopupVisible = flag;
            }
        });

        this.$popup.renderPopups(this.$map.groups);

        return flag;
    }

}
